<script>
import InputField from "@/components/input/InputField.vue"
import {reactive} from "vue"
import { helpers, required} from "@vuelidate/validators"
import {useVuelidate} from "@vuelidate/core"
import {api} from "@/modules/api"
import {toast} from "vue3-toastify";

export default {
  name: 'FormAddress',
  components: {InputField},
  setup() {
    const dataForm = reactive({
      numberRoute: '',
      route: '',
      zipcode: '',
      city: '',
      country: ''
    });

    const rules = {
      dataForm: {
        numberRoute: {required: helpers.withMessage('Ce champs est obligatoire', required)},
        route: { required: helpers.withMessage('Ce champs est obligatoire', required) },
        zipcode: { required: helpers.withMessage('Ce champs est obligatoire', required) },
        city: { required: helpers.withMessage('Ce champs est obligatoire', required) },
        country: { required: helpers.withMessage('Ce champs est obligatoire', required) },
      }
    };

    const v$ = useVuelidate(rules, { dataForm })

    return { dataForm, v$ }
  },
  methods: {
    submit () {
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.isLoading = false
        return;
      }

      api.profil.createAddress(this.dataForm).then(() => {
        this.$emit('closeModal')
        this.emitter.emit('load-data', true)
        toast('Adresse enregistrée ! Pensez à la définir comme principale si nécessaire.')
      })
    }
  }
}
</script>

<template>
  <div class="p-4 md:p-5">
    <div class="grid gap-4 mb-4 grid-cols-2">
      <div class="col-span-2 sm:col-span-1">
        <input-field
            v-model="dataForm.numberRoute"
            label="Numéro de rue"
            type="text"
            placeholder="12"
            :validation="v$.dataForm.numberRoute"
        />
      </div>
      <div class="col-span-2 sm:col-span-1">
        <input-field
            v-model="dataForm.route"
            label="Nom de rue"
            type="text"
            placeholder="rue de paris"
            :validation="v$.dataForm.route"
        />
      </div>
      <div class="col-span-2">
        <input-field
            v-model="dataForm.zipcode"
            label="Code postal"
            type="text"
            placeholder="33000"
            :validation="v$.dataForm.zipcode"
        />
      </div>
      <div class="col-span-2">
        <input-field
            v-model="dataForm.city"
            label="Ville"
            type="text"
            placeholder="Bordeaux"
            :validation="v$.dataForm.city"
        />
      </div>
      <div class="col-span-2">
        <input-field
            v-model="dataForm.country"
            label="Pays"
            type="text"
            placeholder="France"
            :validation="v$.dataForm.country"
        />
      </div>
    </div>
    <button @click="submit" class="text-white inline-flex items-center bg-primary-700 hover:bg-primary-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
      <svg class="me-1 -ms-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
      Ajouter
    </button>
  </div>
</template>
